import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { transientOptions } from '../../../../constants/transientOptions'
import { BorderRadius } from '../../../../enums/borderRadius'
import { Color } from '../../../../enums/color'
import { DefaultValue } from '../../../../enums/defaultValue'
import { FontSize } from '../../../../enums/fontSize'
import { FontWeight } from '../../../../enums/fontWeight'
import { Spacing } from '../../../../enums/spacing'
import { Themable } from '../../../../types/themable'
import { getDefaultTransition } from '../../../../utils/getDefaultTransition'
import { Size } from './types/size'

const sizeToDimension: Record<Size, number> = {
  sm: 40,
}

interface TabButtonWrapperProps extends Themable {
  size: Size
  selected?: boolean
  disabled?: boolean
  fitToWidth?: boolean
}

export const TabButtonWrapper = styled('button', transientOptions)<TabButtonWrapperProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: ${({ size }) => sizeToDimension[size]}px;
  padding-right: ${Spacing.S16};
  padding-left: ${Spacing.S16};
  border: none;
  border-radius: ${BorderRadius.R8};
  background-color: transparent;
  color: ${({ theme }) => theme.ds.colors.base.textSecondary};
  font-family: ${DefaultValue.FontFamily};
  font-size: ${FontSize.TextBodyMD};
  font-weight: ${FontWeight.Bold};
  white-space: nowrap;
  cursor: pointer;
  ${getDefaultTransition('background-color', 'color')}

  /* Disabled */
  ${({ disabled }) =>
    disabled &&
    css`
      background-color: transparent;
      color: ${Color.Grey200};
      cursor: not-allowed;

      ${PrefixWrapper},
      ${SuffixWrapper} {
        opacity: 0.6;
      }
    `}

  /* Selected */
  ${({ disabled, selected, theme }) =>
    !disabled &&
    selected &&
    css`
      background-color: ${Color.White};
      color: ${theme.ds.colors.base.textPrimary};
      cursor: default;
    `}

    /* Hover + Active */
    ${({ selected, disabled, theme }) =>
    !selected &&
    !disabled &&
    css`
      &:hover {
        background-color: ${Color.Grey200};
        color: ${theme.ds.colors.base.textPrimary};
      }
      &:active {
        background-color: ${Color.Grey150};
        color: ${theme.ds.colors.base.textPrimary};
      }
    `}

    ${({ fitToWidth }) =>
    fitToWidth &&
    css`
      flex: 1;
    `}
`

const PrefixSuffixWrapper = styled.div`
  display: flex;
`

export const PrefixWrapper = styled(PrefixSuffixWrapper)`
  &:not(:empty) {
    margin-right: ${Spacing.S8};
  }
`

export const SuffixWrapper = styled(PrefixSuffixWrapper)`
  &:not(:empty) {
    margin-left: ${Spacing.S8};
  }
`
